export enum CategoryType {
    channel = "channel",
    gallery = "gallery",
    externalCategory = "externalCategory",
}
